export const elektronikaData = {
    order: 3,
    name: 'elektronika',
    title: 'Elektronika',
    iconSrc: 'pic_elektronika.svg',
    headlineText:
        'O gaszeniu świateł każdy pamięta, ale sposobów na oszczędzanie energii w domu jest dużo więcej. Dowiedz się, co jeszcze możesz zrobić!',
    mainText:
        'Choć dziś zwracamy coraz większą uwagę na zakup energooszczędnych sprzętów i przeważnie dbamy o gaszenie świateł, wciąż są działania, które możemy wdrożyć w celu ograniczenia zużycia energii i negatywnego wpływu elektroniki na środowisko. Kupując nowy sprzęt elektroniczny, powinniśmy sprawdzić jego klasę energetyczną ale również zorientować się, gdzie i jak zutylizować stare i zużyte urządzenia, gdyż elektrośmieci to jeden z największych problemów naszych czasów. Warto wiedzieć, że niektóre materiały (np. stal i metale szlachetne) można odzyskać poprzez recykling. Temat elektroniki jest więc bezpośrednio związany z racjonalnymi zakupami, segregacją śmieci i energooszczędnością.',
    mainVideoSrc: '',
    odpadySection: [
        {
            text: 'Korzystaj z akumulatorków zamiast baterii – możesz je ładować i ponownie użyć.',
        },
        {
            text:
                'Zepsuty sprzęt elektroniczny często można naprawić niewielkim kosztem. Jeśli już jesteś zdecydowany na zakup nowego, stary odsprzedaj lub oddaj komuś, kto jeszcze będzie mógł z niego korzystać.',
        },
        {
            text:
                'Nie wyrzucaj elektrośmieci na składowisko. Kupując nowy sprzęt, zapytaj, czy firma oferuje też zabranie starego, aby zaś pozbyć się dużego AGD, wezwij do tego specjalną firmę. Sprawdź, gdzie znajduje się najbliższy punkt przyjmujący elektryczne śmieci (najczęściej mieszczą się one w centrach handlowych lub supermarketach).',
        },
        {
            text: '',
            picSrc: 'pics/pic-28.png',
            caption:
                'Zużyte leki, elektronikę i meble oddaj do specjalnych punktów (np. PSZOK). Zużytą elektronikę możesz także oddać podczas organizowanych cyklicznie w Jastrzębiu-Zdroju zbiórek, na których zostanie wymieniona na sadzonki.',
        },
    ],
    klimatSection: [],
    energiaSection: [
        {
            text:
                'Upewnij się, które urządzenia domowego użytku pochłaniają najwięcej energii, aby dowiedzieć się gdzie w pierwszej kolejności należy zacząć oszczędzać. Przykładowo, jeśli codziennie przez godzinę używasz piekarnika, to do rocznego rachunku za prąd dochodzi 200 zł. Laptop pracujący codziennie przez 6 godzin to dodatkowe 48 zł, a odkurzacz o mocy 1600 W używany 2 godziny tygodniowo to aż 90 zł rocznie.',
        },
        {
            text: 'Jakie urządzenia zużywają najwięcej energii?',
            picSrc: 'pics/pic-27.png',
        },
        {
            text: 'Wymień wszystkie żarówki w domu na te energooszczędne.',
        },
        {
            text:
                'Wyłączaj sprzęty, z których w danym momencie nie korzystasz (np. telewizor włączony „w tle"). To samo dotyczy niepotrzebnie zapalonych  świateł.',
        },
        {
            text:
                'Urządzenia pozostawione w trybie czuwania wciąż pobierają mnóstwo energii! Wyłącz je całkowicie.',
        },
        {
            text:
                'Ładowarka do telefonu czy laptopa pozostawiona w gniazdku wciąż pożera energię. Gdy nie ładujesz swoich urządzeń, odłącz ładowarkę z gniazdka.',
        },
        {
            text:
                'Zainwestuj w specjalne wtyczki do gniazdek, które ograniczają zużycie prądu przez sprzęty w czasie gdy nie są używane.',
        },
        {
            text: 'Kupując sprzęty AGD i RTV zwracaj szczególną uwagę na ich klasę energetyczną.',
        },
        {
            text:
                'W wielu przypadkach pranie wstępne nie jest konieczne, podobnie jak pranie w najwyższej temperaturze. Jeśli zrezygnujesz z nich, cykl prania przebiegnie szybciej i zużycie energii elektrycznej będzie mniejsze. Zatem korzystaj z funkcji prania wstępnego tylko w przypadku rzeczy mocno zabrudzonych.',
        },
        {
            text: '',
            picSrc: 'pics/pic-16.png',
            caption:
                'Elektronika: jeśli potrzebujesz nowy sprzęt elektroniczny, popytaj wśród znajomych - może ktoś ma ciekawe urządzenia na sprzedaż?',
        },
        {
            text:
                'W zmywarce na co dzień korzystaj z programów o niskich temperaturach (np. 35°C). Wykorzystanie od czasu do czasu programu 60 °C przyczyni się do samooczyszczenia zmywarki.',
        },
        {
            text:
                'Używaj trybu eco w sprzętach elektronicznych lub ogranicz ich zapotrzebowanie na energię (np. ustaw temp. lodówki na 6 st., zamiast na 2).',
        },
        {
            text:
                'Zainwestuj w panele fotowoltaiczne i zacznij produkować własną energię elektryczną.',
        },
    ],
    powietrzeSection: [],
    wodaSection: [
        {
            text:
                'Program z ekspresowym zmywaniem oszczędza nie tylko energię elektryczną, ale także wodę. Możesz go stosować do niewielkiej ilości naczyń bezpośrednio po posiłku.',
        },
        {
            text: 'Pralkę czy zmywarkę przed włączeniem staraj się zapełnić w 100%.',
        },
    ],
    czyWieszSection: [
        {
            text: '...energia słoneczna jest największym źródłem energii na Ziemi?...',
            more:
                'W każdej chwili otrzymujemy jej 173 000 TW. To ponad 10 tysięcy razy więcej, niż wynosi całkowite zużycie energii na świecie. Do produkcji tej energii nie potrzeba surowców w postaci paliw kopalnych, a jedynie kilka modułów, które pod wpływem światła słonecznego wytwarzają energię elektryczną. Moduły pv nie emitują dwutlenku węgla i innych szkodliwych gazów do atmosfery.',
        },
        {
            text:
                '...Europejczycy posiadają ok. 8 mld sztuk AGD, o wadze ok. 67 mln ton, w której znajduje się ok. 4 mln ton miedzi i 2 mln ton aluminium?...',
            more:
                'Każdy z nas rocznie produkuje ok. 15,6 kg elektroodpadów, z czego tylko 7 kg jest zbieranych i przetwarzanych.' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://www.teraz-srodowisko.pl/aktualnosci/ZSEE-elektroodpady-elektrosmieci-recykling-7847.html">https://www.teraz-srodowisko.pl/aktualnosci/ZSEE-elektroodpady-elektrosmieci-recykling-7847.html</a>',
        },
    ],
};
